export var GenderTypeConfigs = function(strings) {
    /* Public Functions */

    var getConfig = function(countryCode) {
        if ((countryCode.toLowerCase() + 'Config') in configCollection) {
            return new configCollection[countryCode.toLowerCase() + 'Config']();
        } else {
            return new configCollection.baseConfig();
        }
    };

    /* Private Variables */

    // market-specific configs
    var configCollection = {};

    /* Private Functions */

    // helper for setting up inheritance
    var inheritsFrom = function(child, parent) {
        child.prototype = Object.create(parent.prototype);
    };

    /* Configs */

    // base config stubs each property setter
    var BaseConfig = function() {};
    BaseConfig.prototype.getMaleOption = function() {};
    BaseConfig.prototype.getFemaleOption = function() {};
    BaseConfig.prototype.getOtherOption = function() {};
    BaseConfig.prototype.getGenderOptions = function() {};

    configCollection.baseConfig = BaseConfig;

    // Default config overrides a subset of the property setters with behavior common across most markets
    var DefaultConfig = function() {};
    inheritsFrom(DefaultConfig, BaseConfig);
    DefaultConfig.prototype.getMaleOption = function() {
       var male = {
           value: 'male',
           display: strings.get('tdc_maleOption')
       };
       return male;
    };
    DefaultConfig.prototype.getFemaleOption = function() {
        var female = {
            value: 'female',
            display: strings.get('tdc_femaleOption')
        };
        return female;
    };
    DefaultConfig.prototype.getOtherOption = function() {
        var other = {
            value: 'other',
            display: strings.get('tdc_otherOption')
        };
        return other;
    };
    DefaultConfig.prototype.getGenderOptions = function() {
        var genderOptions = [];
        genderOptions.push(DefaultConfig.prototype.getMaleOption(), DefaultConfig.prototype.getFemaleOption(),
            DefaultConfig.prototype.getOtherOption());
        return genderOptions;
    };

    // Alternate config overrides a subset of the property setters with behavior common across most markets
    var AlternateConfig = function() {};
    inheritsFrom(AlternateConfig, BaseConfig);
    AlternateConfig.prototype.getMaleOption = function() {
        var male = {
            value: 'male',
            display: strings.get('tdc_maleOption')
        };
        return male;
    };
    AlternateConfig.prototype.getFemaleOption = function() {
        var female = {
            value: 'female',
            display: strings.get('tdc_femaleOption')
        };
        return female;
    };
    AlternateConfig.prototype.getGenderOptions = function() {
        var genderOptions = [];
        genderOptions.push(DefaultConfig.prototype.getMaleOption(), DefaultConfig.prototype.getFemaleOption());
        return genderOptions;
    };

    // US config for US market
    var UsConfig = function() {};
    inheritsFrom(UsConfig, DefaultConfig);
    configCollection.usConfig = UsConfig;

    // CA config for Canadian market
    var CaConfig = function() {};
    inheritsFrom(CaConfig, DefaultConfig);
    configCollection.caConfig = CaConfig;


    /* Expose Public Functions */

    return {
        getConfig: getConfig
    };
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/gender-types/gender-type-configurations.js
// module id = 351
// module chunks = 0